export const SELF_BNB_LP_MAINNET = '0x9C6FF656A563Ec9057460D8a400E2AC7c2AE0a1C'
export const CAKE_BNB_LP_MAINNET = '0x0eD7e52944161450477ee417DE9Cd3a859b14fD0'